import { render, staticRenderFns } from "./jpointSettingEdit.vue?vue&type=template&id=9f5f12aa&scoped=true"
import script from "./jpointSettingEdit.vue?vue&type=script&lang=js"
export * from "./jpointSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./jpointSettingEdit.vue?vue&type=style&index=0&id=9f5f12aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5f12aa",
  null
  
)

export default component.exports